import request from '@/plugin/axios'

export function AccountLogin(data) {
  return request({
    url: '/WebApis/LoginHandler.ashx?action=Login',
    method: 'post',
    data,
    loading: {
      type: 'loading',
      options: {
        fullscreen: true,
        lock: true,
        text: '正在登陆...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)'
      }
    }
  })
}
